module.exports = __webpack_public_path__ + "img/pr-7.8aeae258.png";